import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { apiRequest } from "../../../shared/api/client";
import { parseTechnicalBoardResponse, technicalManagerSummary, type BoardResponse } from "./technical-manager-presentation";

export function useTechnicalManagerWorkspace({refreshVersion,notify}:{refreshVersion:number;notify:(message:string)=>void}) {
const [view,setView]=useState<"calls"|"team">("calls");
const [data,setData]=useState<BoardResponse>({items:[],onDutyTeam:[],generatedAt:""});
const [loading,setLoading]=useState(true);
const [refreshing,setRefreshing]=useState(false);
const [error,setError]=useState("");
const [now,setNow]=useState(()=>Date.now());
const generation=useRef(0);
const mounted=useRef(false);
const pending=useRef(false);
useEffect(()=>{mounted.current=true;return()=>{mounted.current=false;generation.current++;pending.current=false;};},[]);
const load=useCallback(async(silent=false)=>{
    if(!mounted.current || (silent && pending.current)) return;
    const token=++generation.current;pending.current=true;
    if(silent)setRefreshing(true);else setLoading(true);
    try{const response=await apiRequest<unknown>("/api/production/technical-calls/board",{cache:"no-store"});if(!mounted.current||token!==generation.current)return;setData(parseTechnicalBoardResponse(response));setError("");}
    catch(nextError){if(!mounted.current||token!==generation.current)return;const message=nextError instanceof Error?nextError.message:"Teknik çağrılar yüklenemedi.";setError(message);if(!silent)notify(message);}
    finally{if(mounted.current&&token===generation.current){pending.current=false;setLoading(false);setRefreshing(false);}}
  },[notify]);
useEffect(()=>{void load();},[load,refreshVersion]);
useEffect(()=>{const interval=window.setInterval(()=>void load(true),15_000);return()=>window.clearInterval(interval);},[load]);
useEffect(()=>{const interval=window.setInterval(()=>setNow(Date.now()),30_000);return()=>window.clearInterval(interval);},[]);
const {items,unclaimed,stopped,available}=useMemo(()=>technicalManagerSummary(data),[data]);
return { view, setView, data, loading, refreshing, error, now, load, items, unclaimed, stopped, available };
}
